import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const CriteoPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Criteo"
      description="Step-by-step instructions for adding your Upfeed product feed to Criteo for Dynamic Retargeting campaigns."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Criteo</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to Criteo so
            you can run Dynamic Retargeting campaigns that show your products to
            shoppers across the web.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>A Criteo One account.</li>
            </ul>
          </div>

          <h2>Setting up your Criteo product catalog</h2>
          <ul>
            <li>
              Log in to Criteo One and navigate to Assets &gt; Catalogs in the
              left menu.
            </li>
            <li>Click 'Create Catalog' and give your catalog a name.</li>
            <li>Select 'Scheduled Feed' as the data source type.</li>
            <li>Paste your product feed URL from the app.</li>
            <li>Set the refresh frequency to 'Daily' and click 'Save'.</li>
            <li>
              Wait for Criteo to validate and import your product catalog — this
              may take a few hours on the first run.
            </li>
          </ul>

          <h2>Running Dynamic Retargeting campaigns</h2>
          <p>
            Once your catalog is live, you can create a Dynamic Retargeting
            campaign in Criteo One and link it to your product catalog. If you
            are working with a Criteo account manager, share your catalog with
            them to connect it to your existing campaigns.
          </p>

          <RelatedPlatforms currentSlug="criteo" />
        </div>
      </div>
    </div>
  </Layout>
)

export default CriteoPage
